var checkboxData = {
  name: 'checkbox',
  data: [{
    radius: 2,
    fontSize: 12,
    boxSize: 14,
    fontColor: '#5A6677',
    shadow: '0 0 0 1px rgba(0, 0, 0, 0.15)',
    borderColor: '#ccc'
  }]
};
export default checkboxData;